module.exports = __webpack_public_path__ + "img/queuedNphies.9237d9dc.svg";